import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a7d91b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reward-container" }
const _hoisted_2 = { class: "main-label" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_4 = { class: "flex my-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rewards-label" }, null, -1))
const _hoisted_6 = { class: "rewards-current-title" }
const _hoisted_7 = { class: "rewards-min-max-title-container" }
const _hoisted_8 = { class: "rewards-min underline" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rewards-dash" }, "-", -1))
const _hoisted_10 = { class: "rewards-max underline" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "rewards-label" }
const _hoisted_13 = { class: "rewards-current-value" }
const _hoisted_14 = { class: "rewards-min-max-value-container" }
const _hoisted_15 = { class: "rewards-min" }
const _hoisted_16 = { class: "rewards-dash" }
const _hoisted_17 = { class: "rewards-max" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_20 = { class: "rewards-label" }
const _hoisted_21 = { class: "rewards-current-value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rewards-min-max-value-container" }, null, -1))
const _hoisted_23 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_24 = { class: "rewards-label" }
const _hoisted_25 = { class: "rewards-current-value" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rewards-min-max-value-container" }, null, -1))
const _hoisted_27 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_28 = { class: "rewards-label" }
const _hoisted_29 = { class: "rewards-current-value" }
const _hoisted_30 = { class: "rewards-min-max-value-container" }
const _hoisted_31 = { class: "rewards-min" }
const _hoisted_32 = { class: "rewards-dash" }
const _hoisted_33 = { class: "rewards-max" }
const _hoisted_34 = {
  key: 3,
  class: "flex"
}
const _hoisted_35 = { class: "rewards-label" }
const _hoisted_36 = { class: "rewards-current-value" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rewards-min-max-value-container" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('rewards')) + " ", 1),
      _createVNode(_component_BalIcon, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showRewardsDetail = !_ctx.showRewardsDetail)),
        class: "cursor-pointer ml-auto text-amber-550",
        name: 
          _ctx.showRewardsDetail
            ? 'ant-design:minus-circle-outlined'
            : 'ant-design:plus-circle-outlined'
        ,
        size: "sm"
      }, null, 8, ["name"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('current')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('min')), 1),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('max').toLowerCase()), 1)
      ])
    ]),
    (!_ctx.showRewardsDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTotal, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex my-1",
              key: index
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t(item.label)) + ":", 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.farmVault[item.value] ? _ctx.showApr(_ctx.farmVault[item.value]) + '%' : '--'), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.farmVault[item.min] ? _ctx.showApr(_ctx.farmVault[item.min]) : ''), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.farmVault[item.min] ? '-' : ''), 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.farmVault[item.max] ? `${_ctx.showApr(_ctx.farmVault[item.max])}%` : ''), 1)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (_ctx.farmVault.swapApy)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSwap, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t(item.label)) + ":", 1),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(`${_ctx.showApr(_ctx.farmVault[item.value])}%`), 1),
                    _hoisted_22
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.farmVault.vaultApy)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataVault, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t(item.label)) + ":", 1),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(`${_ctx.showApr(_ctx.farmVault[item.value])}%`), 1),
                    _hoisted_26
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.farmVault.farmApy)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataFarm, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t(item.label)) + ":", 1),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.farmVault[item.boosted]
                ? `${_ctx.showApr(_ctx.farmVault[item.boosted])}%`
                : _ctx.farmVault[item.value]
                ? `${_ctx.showApr(_ctx.farmVault[item.value])}%`
                : '--'), 1),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.farmVault[item.min] ? _ctx.showApr(_ctx.farmVault[item.min]) : ''), 1),
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.farmVault[item.min] ? '-' : ''), 1),
                      _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.farmVault[item.max] ? `${_ctx.showApr(_ctx.farmVault[item.max])}%` : ''), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.farmVault.farm && _ctx.farmVault.farm.allocPoint)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('acs_weight')) + ":", 1),
                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.farmVault.farm.allocPoint / 100) + "X ", 1),
                _hoisted_37
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}